import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <>
      <div className="download-footer-w">
        <div className="container">
          <div className="download-footer-email">
            <div className="download-footer-left">
              Need help ? Write to{" "}
              <a
                href="#"
                onClick={() =>
                  (window.location = "mailto:saas-support@carbn.in")
                }
              >
                saas-support@carbn.in
              </a>
            </div>
            <div className="download-footer-right">&#169; 2024 CARBN</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
